import i18n from "@/lang";

const wordsMap = {
  'coins': () => { return i18n.t('lang.paidCall.coins') },
}

export function getVibeoWords () {
  const tempWordsObj = {}

  Object.keys(wordsMap).forEach(wordKey => {
    tempWordsObj[wordKey] = wordsMap[wordKey]()
  })

  return tempWordsObj
}

export default getVibeoWords